'use client'

import { useSearchParams } from 'next/navigation'
import { Link } from '@/frontend/design-system/actions/Link'
import { P3 } from '@/frontend/design-system/typography/Paragraph'

export function LoginButton() {
  const searchParams = useSearchParams()
  const redirectTo = searchParams.get('redirectTo') ?? '/app'

  return (
    <P3 className='text-center'>
      Masz już konto?{' '}
      <Link
        href={`/auth/login?redirectTo=${encodeURIComponent(redirectTo)}`}
        className='font-medium text-contentNavyAlgo hover:underline'
      >
        Zaloguj się
      </Link>
    </P3>
  )
}
